import { useQuery } from '@tanstack/react-query';

import { ServiceFactory } from '../../services/ServiceFactory';
import { McpProduct } from '../../types/product/product';
import { ISelection } from '../../types/selector/Selector';

interface UseConvertProduct {
  product?: McpProduct,
  status: 'error' | 'pending' | 'success',
  error?: string,
  isRefetching: boolean
}

/**
 * Hook for converting a CimCommerce product to an MCP product
 * @returns
 */
export const useConvertProduct = (
  variableAttributes: ISelection,
  shouldConvert: boolean = true,
  productKey?: string,
  customHeaders?: Record<string, string>,
): UseConvertProduct => {
  const productService = ServiceFactory.createProductService();
  const {
    data: product, status, error, isRefetching,
  } = useQuery<McpProduct | undefined, { message: string }>({
    queryKey: ['convertedProduct', productKey, variableAttributes],
    queryFn: () => productService.convertProduct(variableAttributes, productKey, customHeaders),
    enabled: shouldConvert,
    placeholderData: (previousData) => previousData,
    gcTime: Infinity,
    staleTime: Infinity,
  });

  return {
    product,
    status,
    error: error?.message,
    isRefetching,
  };
};
